import { Box, Modal, Typography, useTheme } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';
import React from 'react';
import { colorTheme } from 'theme';

export interface IDialogProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children?: React.ReactNode;
  viewImageUrl?: string | null;
}

const ImageViewModal = (props: IDialogProps): JSX.Element => {
  const { title, onClose, open, viewImageUrl } = props;
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);

  const customStyles = {
    boxStyle: {
      position: 'absolute' as const,
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      bgcolor: 'background.paper',
      boxShadow: 24,
      py: 2,
      px: 2,
      width: '90vw',
      maxWidth: '600px',
      borderRadius: 5,
    },
    subBoxStyle: {
      display: 'flex',
      justifyContent: 'flex-end',
      cursor: 'pointer',
    },
    iconStyle: {
      bgcolor: colors.gray[900],
      borderRadius: 10,
    },
    titleStyle: {
      textAlign: 'center',
    },
    mbStyle: {
      marginBlock: 1,
      textAlign: 'center',
    },
    imageStyle: {
      maxWidth: '100%',
      maxHeight: '75vh',
      objectFit: 'contain',
    },
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={customStyles.boxStyle}>
        <Box onClick={onClose} sx={customStyles.subBoxStyle}>
          <GridCloseIcon sx={customStyles.iconStyle} />
        </Box>
        <Typography variant="h5" component="h2" sx={customStyles.titleStyle}>
          {title}
        </Typography>
        <Box sx={customStyles.mbStyle}>
          {viewImageUrl && (
            <img
              src={viewImageUrl}
              alt="Image"
              style={customStyles.imageStyle}
            />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ImageViewModal;
